<template>
  <div>
    <footer class="foot-wrap pd-b20">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="foot-content-wrap">
              <div class="foot-logo">
                <!-- <img src="/images/foot-logo.png" alt="" title="" /> -->
                <img src="/images/footer-logo.svg" alt="" title="" />
              </div>
              <div class="foot-copy-text">
                <p
                  >© Copyright {{ currentYear }} BuildingLink.com LLC. All
                  Rights Reserved. 85 Fifth Avenue, 3rd Floor, New York, NY
                  10003.</p
                >
              </div>
              <!-- <div class="foot-links2">
                Privacy Policy  |
                Terms and Conditions
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear(),
    }
  },
}
</script>
<style scoped>
@media (max-width: 767px) {
  .foot-content-wrap {
    display: block;
    margin-left: 0;
  }
  .foot-logo img {
    margin-left: -9px;
  }
  .foot-copy-text p {
    margin-left: 0;
  }
}
</style>
